import { OktaAuth } from '@okta/okta-auth-js';
import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { from, Observable } from 'rxjs';
import { UserClaims } from '@core/interfaces/okta/UserClaims';
import { map } from 'rxjs/operators';
import { OKTA_AUTH } from '@okta/okta-angular';



export function MedicareUserGuardFn(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree{
  const router: Router = inject(Router);
  const oktaAuth : OktaAuth = inject(OKTA_AUTH);

  return from(oktaAuth.getUser()).pipe(map((user: UserClaims) => {
    const hasMedicareGroup = (user?.groups || []).some((group) => group.toLowerCase().replace(/ /g, '-') === 'mpsr-users');
    if (hasMedicareGroup) {
      return true;
    }
    router.navigate(['/session-expired']);
    return false;
  }));
}

